let PUBLIC_KEY = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuSv/I8mO7GHpcs+brTDtRVw8gmkPO+uLISkcMIiFkq1Q3+gwK36OoB1NkxbDbLukNLo0r5qR+SJFCvqws/kbLj056mC4HBjFXv+pw5zwWCnRuyCJEjPz6se793gNK9Oa57pyl0Pme19AVO0oGn3eqwFF//lnt+wq6n0OINq8+rN1wkLrudg+l1RmXE8VMPFnHdazeovu2V9lB/QAdU6v1/Qj/hNp92Mca+iAvYP+wd+JPIKuGKL5tdrBV7fdBbF193Fv8eXcGKjdVVU+RQAPPUswN3W7DwOIB/gbvo6Vrq0HViNl2TRzm4AyziGBjV6Co8fYaFnYK8zbJtOX3HRl8QIDAQAB
-----END PUBLIC KEY-----
`;

if (process.env.VUE_APP_RUNTIME_ENV !== 'prod') {
  PUBLIC_KEY = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA4U4yT22/368bVcAD/OLGW2jFV4A5ePARM4DxAoZQBIkJQoGXp5fHm3gX/GqFnTZGYTQdrmgV3Mbzk2uGmXC60e1EUwE7AzK7usXP+onPJZFtbeouVyv3kNDmuj0NpPOSauqsBEeY6jhIxDYtvRrsWBVtlMNUi7WX71nx0pCOqGq+kbkR8mchfMnfhKNXVvgjCsbPUNT63hyE9u9SDPYZEGZ61xQXy1X9nFQ1jVB+VbacUurAiXPAdW21Yuj17SRSK8xWGeA3USXVHvUAnnmtOcSCzaNoBuvnyOkxe9hHLHTAIRj2tyicV5BuJuaUOAmSsmg4Hr/JKJzoejhkNX210wIDAQAB
-----END PUBLIC KEY-----
`;
}

export default PUBLIC_KEY;
